import React from "react";
import { FormattedMessage } from "react-intl";
import { Col, Row } from "reactstrap";
import { isYoutubePostingEnabled } from "../../../cores/config/featureFlags";
import { GmailBindRow } from "./social/GmailBindRow";
import { GoogleCalendarBindRow } from "./social/GoogleCalendarBindRow";
import { YouTubeBindRow } from "./social/YouTubeBindRow";
import { SmtpBindRow } from "./social/SmtpBindRow";
import { Office365BindRow } from "./social/Office365BindRow";
import "./IntegrationForm.scss";

export const IntegrationForm = () => {
  return (
    <Row className="user-integration-form my-2">
      <Col xs="12">
        <div className="user-integration-form__intro-card mb-4">
          <div className="user-integration-form__intro-icon">i</div>
          <p className="small text-muted user-integration-form__intro mb-0">
            <FormattedMessage id="app.userIntegrations.intro" />
          </p>
        </div>
        <GmailBindRow />
        <Office365BindRow />
        <SmtpBindRow />
        <GoogleCalendarBindRow showIntegrationDescription />
        {isYoutubePostingEnabled() ? (
          <YouTubeBindRow showIntegrationDescription />
        ) : null}
      </Col>
    </Row>
  );
};
